import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 70,
    cssOverrides: {
        drawerBody: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 130px;
                    `,
                    css`
                        height: 130px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 15px;
            margin: 0 auto;
            width: 100%;
            > ${GridWrapper} {
                > ${GridOffset} {
                    justify-content: center;
                }
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};
